import {
  Box,
  Button,
  ButtonProps,
  Container,
  Dialog,
  IconButton,
  InputAdornment,
  Typography,
  Pagination,
  Stack,
  styled,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import variables from "../../../assets/styles/variables.module.scss";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import KnowledgeBaseCard from "../../../Shared-ui/SharedComponents/Cards/KnowledgeBaseCard";
import KnowledgeBaseForm from "../../Components/CreateKnowledgeBase";
import { KnowledgeBase } from "../../../Shared-ui/Types/KnowledgeBase";
import { useDispatch, useSelector } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { KNOWLEDGE_BASE } from "../../../Services/Endpoint";
import Confirm from "../../../Shared-ui/Types/Confirm";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import SearchIcon from "@mui/icons-material/Search";
import Emptystateimage from "../../../assets/images/Agents_emptystateimage.svg"
import { set } from "date-fns";

// import CreateKnowledgeBaseDialog from "../../Components/CreateKnowledgeBaseDialog";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));


const KnowledgeBases: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch()
  const [knowledgeBases, setKnowledgeBases] = useState<KnowledgeBase[]>([])
  const [knowledgeBasesAll, setKnowledgeBasesAll] = useState<KnowledgeBase[]>([])
  const [knowledgeBase, setKnowledgeBase] = useState<KnowledgeBase | null>(null)
  const [searchText, setSearchText] = useState<string>("")
  // State for modal
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const prevPage = useRef<number>(page);
  const pageLimitRef = useRef(12)
  const loaderStatus = useSelector((state: any) => state.LoaderReducer);

  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false })

  const [totalKnowledgeBases, setTotalKnowledgeBases] = useState<number>(0);
  const isFirstRender = useRef(true);

  const handleOpen = () => {
    setOpen(true)
  }


  // useEffect(() => {
  //   getKnowledgeBases()
  // }, [])

  useEffect(() => {
    if (!searchText) {
      setPage(1);
      getKnowledgeBases();
    }
  }, [searchText]);



  useEffect(() => {
    if (prevPage.current !== page) {
      getKnowledgeBases();
      prevPage.current = page;
    }
  }, [page])




  const getKnowledgeBases = async (searchText?: string) => {
    try {
      dispatch(StartLoading("Knowledge"));
      var url = `${KNOWLEDGE_BASE}?page=${page}&page_size=${limit}`;
      if (searchText) {
        url += `&search=${searchText}`;
      }
      const data = await BaseInstance.get(url).then(
        (res) => res?.data
      );
      // data?.items?.sort((a: { created_at: string }, b: { created_at: string }) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
      setKnowledgeBases(data.items)
      setTotalKnowledgeBases(data.pagination.total || 0)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading("Knowledge"));

    }

  }

  const deleteknowledge = async (knowledgeBase: KnowledgeBase) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading());
      const data = await BaseInstance.delete(`${KNOWLEDGE_BASE}/${knowledgeBase.id}`).then(
        (res) => res?.data
      );
      getKnowledgeBases()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }

  }
  const confirmDelete = (row: KnowledgeBase) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: deleteknowledge,
      functionParam: row
    })
  }


  const editingKnowledgeBase = (knowledgeBase: KnowledgeBase) => {
    setKnowledgeBase(preVal => {
      setOpen(true)
      return { ...preVal, ...knowledgeBase }
    })

  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleClose = () => {
    setOpen(false);
    getKnowledgeBases()
    setKnowledgeBase(null);
  }

  const handleSearch = () => {
    setPage(1);
    getKnowledgeBases(searchText);

  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: { xs: 3, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Knowledge", path: "" }]} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "400px", md: "auto" },
          }}
        >
          <TextField
            placeholder="Search Knowledge"
            variant="outlined"
            size="small"
            sx={{
              width: { xs: "100%", sm: "350px" },
              flex: { xs: 1, sm: 1, md: "none" },
            }}
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch} // your custom function
                    edge="end"
                    size="small"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              fontWeight: "400",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
              "& .MuiButton-startIcon": {
                mr: { xs: 0, sm: 1 },
              },
            }}
            onClick={handleOpen}
          >
            {!isSmallScreen && "Create Knowledge"}
          </ColorButton>
        </Box>
      </Box>
      {/* Knowledge Base Cards Layout using MUI Stack */}

      {knowledgeBases.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xl: "repeat(4, minmax(0, 1fr))",
              lg: "repeat(4, minmax(0, 1fr))",
              md: "repeat(3, minmax(0, 1fr))",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 3,
            gridAutoRows: "1fr",
          }}
        >
          {knowledgeBases.map((knowledgeBase) => (
            <Box key={knowledgeBase.id} sx={{ width: "100%" }}>
              <KnowledgeBaseCard
                knowledgeBase={knowledgeBase}
                deleteFun={confirmDelete}
                editFun={editingKnowledgeBase}
                getKnowledgeBases={getKnowledgeBases}
              />
            </Box>
          ))}
        </Box>
      )}

      {totalKnowledgeBases === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 6,
          }}
        >

          {loaderStatus.isLoading &&
            loaderStatus.pageName === "Knowledge" && (
              <>
                <img
                  src={Emptystateimage}
                  alt="No Knowledge Bases"
                  style={{ width: 120, height: "auto" }}
                />
                <Typography variant="h6" color="text.secondary">
                  Knowledge loading...
                </Typography>
              </>

            )}
          {!loaderStatus.isLoading &&
            loaderStatus.pageName === "Knowledge" && (
              <>
                <img
                  src={Emptystateimage}
                  alt="No Knowledge Bases"
                  style={{ width: 120, height: "auto" }}
                />
                <Typography variant="h6" color="text.secondary">
                  No Knowledge found
                </Typography>
              </>

            )}
        </Box>
      )}


      {/* Pagination for Knowledge Bases */}
      {totalKnowledgeBases > limit && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={Math.ceil(totalKnowledgeBases / limit)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}

      {/* <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <CreateKnowledgeBaseDialog open={open} handleClose={handleClose} />
      </Dialog> */}
      <KnowledgeBaseForm
        open={open}
        handleClose={handleClose}
        knowledgeBase={knowledgeBase}
      />
      <ConfirmPopup details={confirmPopupData} />
    </Container>
  );
};

export default KnowledgeBases;
